import script from "./PosCollectionReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./PosCollectionReportList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__